import React from "react";
import { connect } from "react-redux";
import { fetchSavedCardsAmplify, getOrCreateStripeCustomer, setLoader } from "../../actions";
import requireAuth from "../requireAuth";
import AccountNav from "../AccountNav";

class AccountSavedCardsPage extends React.Component {
  componentDidMount = () => {
    const mobile = localStorage.mobile || this.props.auth?.mobile || '';
    const email = localStorage.email || this.props.auth?.email || '';
    const name = `${this.props.auth?.first_name || ''} ${this.props.auth?.last_name || ''}`.trim();

    if (!mobile) {
      this.props.setLoader(false, null);
      return;
    }

    this.props.setLoader(true, "Fetching Cards...");

    // First get/create Stripe customer, then fetch their saved cards
    this.props.getOrCreateStripeCustomer(mobile, email, name, (result) => {
      if (result?.success && result?.stripeCustomerId) {
        this.props.fetchSavedCardsAmplify(result.stripeCustomerId, () => {
          this.props.setLoader(false, null);
        });
      } else {
        this.props.setLoader(false, null);
      }
    });
  }

  renderSavedCards = () => {
    return this.props.saved_cards.map((v, i, a) => { 

      let month = v.exp_month < 10 ? "0" + v.exp_month : v.exp_month
      let year = v.exp_year.toString().substring(2, 4); 
      let expiry = month + "/" + year

      let brand = v.brand.toUpperCase()
      switch (v.brand) {
        case 'visa':
          brand = <img className="account-saved-card-brand-img" src="https://cdn.tap2buy.com/card_logos/visa_card.png" />
          break;

        case 'mastercard':
          brand = <img className="account-saved-card-brand-img" src="https://cdn.tap2buy.com/card_logos/mastercard_card.png" />
          break;
        
        case 'amex':
          brand = <img className="account-saved-card-brand-img" src="https://cdn.tap2buy.com/card_logos/amex_card.png" /> 
          break;

        case 'jcb':
          brand = <img className="account-saved-card-brand-img" src="https://cdn.tap2buy.com/card_logos/jcb_card.png" />
          break;

        case 'unionpay':
          brand = <img className="account-saved-card-brand-img" src="https://cdn.tap2buy.com/card_logos/unionpay_card.png" />
          break;
      
        default:
          break;
      }

      return (
        <div key={v.id} className="account-saved-card">
          <div className="account-saved-card-brand">{brand}</div>
          <div className="account-saved-card-number">**{v.last4}</div>
          <div className="account-saved-card-expiry">expiry {expiry}</div>   
        </div>
      )
    })
  }

  render() {
    return (
      <div id="page-account-saved-cards">
        <AccountNav /> 
        <div id="account-content">
          <h1 className="h1">Saved Cards</h1>  
          <div id="account-saved-cards">
            {this.renderSavedCards()}  
          </div> 
        </div>
      </div>
      
    );
  }
}

const mapStateToProps = state => {
  return {
    saved_cards: state.saved_cards.saved_cards,
    auth: state.auth,
  };
};

export default requireAuth(
  connect(
    mapStateToProps,
    { fetchSavedCardsAmplify, getOrCreateStripeCustomer, setLoader }
  )(AccountSavedCardsPage)
);
